<nz-page-header nzTitle="Policy Editor"></nz-page-header>

<nz-spin [nzSpinning]="loading">
	<div *ngIf="policy">
		<div nz-row [nzGutter]="16" class="equal-row">

			<!-- MEMBER -->
			<div nz-col nzSpan="8" class="equal-col">
				<nz-card nzTitle="Member Details">
					<p><strong>Name:</strong> {{ policy.member!.name }} {{ policy.member!.surname }}</p>
					<p><strong>ID Number:</strong> {{ policy.member!.idNumber }}</p>
					<p><strong>Date of Birth:</strong> {{ policy.member!.dateOfBirth | date }}</p>
					<p><strong>Phone:</strong> {{ policy.member!.msisdn || '-' }}</p>
					<p><strong>Email:</strong> {{ policy.member!.emailAddress || '-' }}</p>
				</nz-card>
			</div>

			<!-- PRODUCT -->
			<div nz-col nzSpan="8" class="equal-col">
				<nz-card nzTitle="Product Details">
					<p><strong>Product Name:</strong> {{ policy.product!.name }}</p>
					<p><strong>Product Description:</strong> {{ policy.product!.description }}</p>
					<p><strong>Type:</strong> {{ policy.product!.productType }}</p>
					<p><strong>Benefit Type:</strong> {{ policy.product!.benefitType }}</p>
					<p><strong>Offer Name:</strong> {{ policy.productOffer!.name }}</p>
					<p><strong>Offer Description:</strong> {{ policy.productOffer!.description }}</p>
				</nz-card>
			</div>

			<!-- Premium -->
			<div nz-col nzSpan="8" class="equal-col">
				<nz-card nzTitle="Premium">

				<!-- Header -->
				<div class="premium-row">
					<span class="premium-label"></span>
					<span class="premium-col-header">Current</span>
					<span class="premium-col-header">New</span>
				</div>

				<div class="premium-row">
					<span class="premium-label">Compulsory</span>
					<span class="premium-value">{{ currentPremiumCompulsory }}</span>
					<span class="premium-value">{{ getCompulsoryPremiums() }}</span>
				</div>

				<div class="premium-row">
					<span class="premium-label">Add On</span>
					<span class="premium-value">{{ currentPremiumAddOn }}</span>
					<span class="premium-value">{{ getAddOnPremiums() }}</span>
				</div>

				<div class="premium-row">
					<span class="premium-label">Extended Cover</span>
					<span class="premium-value">{{ currentPremiumExtended }}</span>
					<span class="premium-value">{{ getExtendedPremiums() }}</span>
				</div>

				<nz-divider style="margin: 10px 0"></nz-divider>

				<div class="premium-row premium-total">
					<span class="premium-label">Total Premium</span>
					<span class="premium-value">{{ currentPremiumTotal }}</span>
					<span class="premium-value">{{ getTotalPremiums() }}</span>
				</div>

				</nz-card>
			</div>
		</div>

		<!-- POLICY FORM -->
		<form nz-form [formGroup]="policyForm!" nzLayout="vertical" class="mt-4">
			<nz-divider nzText="Policy Details"></nz-divider>

			<div class="policy-form-sections">

				<!-- Policy Identifiers -->
				<div class="form-section">
					<p class="section-label">
						<span nz-icon nzType="file-text" nzTheme="outline"></span>
						Policy identifiers
					</p>
					<div nz-row [nzGutter]="16">
						<div nz-col nzSpan="5">
							<nz-form-item>
								<nz-form-label nzRequired>Policy number</nz-form-label>
								<nz-form-control nzErrorTip="Required">
									<input nz-input formControlName="policyNumber" placeholder="Policy number" [readOnly]="true" />
								</nz-form-control>
							</nz-form-item>
						</div>
						<div nz-col nzSpan="5">
							<nz-form-item>
								<nz-form-label>Alt</nz-form-label>
								<nz-form-control>
									<input nz-input formControlName="policyNumberAlt" placeholder="Alternative number" />
								</nz-form-control>
							</nz-form-item>
						</div>
						<div nz-col nzSpan="5">
							<nz-form-item>
								<nz-form-label>Industry</nz-form-label>
								<nz-form-control>
									<input nz-input formControlName="policyNumberIndustry" placeholder="Industry number" />
								</nz-form-control>
							</nz-form-item>
						</div>
						<div nz-col nzSpan="5">
							<nz-form-item>
								<nz-form-label>Owls</nz-form-label>
								<nz-form-control>
									<input nz-input formControlName="policyNumberOwls" placeholder="Owls number" />
								</nz-form-control>
							</nz-form-item>
						</div>
						<div nz-col nzSpan="4">
							<nz-form-item>
								<nz-form-label>Membership</nz-form-label>
								<nz-form-control>
									<input nz-input formControlName="policyNumberMembership" placeholder="Membership number" />
								</nz-form-control>
							</nz-form-item>
						</div>
					</div>
				</div>

				<!-- Financial Details -->
				<div class="form-section">
					<p class="section-label">
						<span nz-icon nzType="dollar-circle" nzTheme="outline"></span>
						Financial details
					</p>
					<div nz-row [nzGutter]="16">
						<div nz-col nzSpan="8">
							<nz-form-item>
								<nz-form-label>Current salary</nz-form-label>
								<nz-form-control>
									<nz-input-number
										formControlName="currentSalary"
										[nzMin]="0"
										[nzFormatter]="currencyFormatter"
										[nzParser]="currencyParser"
										style="width: 100%">
									</nz-input-number>
								</nz-form-control>
							</nz-form-item>
						</div>
						<div nz-col nzSpan="8">
							<nz-form-item>
								<nz-form-label>Current loan amount</nz-form-label>
								<nz-form-control>
									<nz-input-number
										formControlName="currentLoanAmount"
										[nzMin]="0"
										[nzFormatter]="currencyFormatter"
										[nzParser]="currencyParser"
										style="width: 100%">
									</nz-input-number>
								</nz-form-control>
							</nz-form-item>
						</div>
					</div>
				</div>

				<!-- Employment -->
				<div class="form-section">
					<p class="section-label">
						<span nz-icon nzType="solution" nzTheme="outline"></span>
						Employment
					</p>
					<div nz-row [nzGutter]="16">
						<div nz-col nzSpan="12">
							<nz-form-item>
								<nz-form-label>Employer</nz-form-label>
								<nz-form-control nzErrorTip="Please enter a value">
									<nz-select nzShowSearch nzAllowClear formControlName="employer" [compareWith]="compareById">
										<nz-option *ngFor="let item of availableEmployers" [nzValue]="item" nzLabel="{{item.name}}"></nz-option>
									</nz-select>
								</nz-form-control>
							</nz-form-item>
						</div>
						<div nz-col nzSpan="12">
							<nz-form-item>
								<nz-form-label>Policy Group</nz-form-label>
								<nz-form-control nzErrorTip="Please enter a value">
									<nz-select nzShowSearch nzAllowClear formControlName="policyGroup" [compareWith]="compareById">
										<nz-option *ngFor="let item of availablePolicyGroups" [nzValue]="item" nzLabel="{{item.name}} ({{item.typeLabel}})"></nz-option>
									</nz-select>
								</nz-form-control>
							</nz-form-item>
						</div>
					</div>
					<div nz-row [nzGutter]="16">
						<div nz-col nzSpan="5">
							<nz-form-item>
								<nz-form-label>Job title</nz-form-label>
								<nz-form-control>
									<input nz-input formControlName="jobTitle" placeholder="Job title" />
								</nz-form-control>
							</nz-form-item>
						</div>
						<div nz-col nzSpan="10">
							<nz-form-item>
								<nz-form-label>Occupation</nz-form-label>
								<nz-form-control>
									<input nz-input formControlName="occupation" placeholder="Occupation" />
								</nz-form-control>
							</nz-form-item>
						</div>
						<div nz-col nzSpan="9">
							<nz-form-item>
								<nz-form-label>Occupation date</nz-form-label>
								<nz-form-control>
									<nz-date-picker formControlName="occupationDate" style="width: 100%"></nz-date-picker>
								</nz-form-control>
							</nz-form-item>
						</div>
					</div>
				</div>

				<!-- Policy Period -->
				<div class="form-section">
					<p class="section-label">
						<span nz-icon nzType="calendar" nzTheme="outline"></span>
						Policy period
					</p>
					<div nz-row [nzGutter]="16">
						<div nz-col nzSpan="8">
							<nz-form-item>
								<nz-form-label nzRequired>From date</nz-form-label>
								<nz-form-control nzErrorTip="Required">
									<nz-date-picker formControlName="fromDate" style="width: 100%"></nz-date-picker>
								</nz-form-control>
							</nz-form-item>
						</div>
						<div nz-col nzSpan="8">
							<nz-form-item>
								<nz-form-label nzRequired>To date</nz-form-label>
								<nz-form-control nzErrorTip="Required">
									<nz-date-picker formControlName="toDate" style="width: 100%"></nz-date-picker>
								</nz-form-control>
							</nz-form-item>
						</div>
					</div>
				</div>

			</div>


			<nz-divider nzText="Product Offer Lines"></nz-divider>

			<nz-table #offerLinesTable [nzData]="policy.productOffer!.lines" [nzShowPagination]="false" nzSize="small"
				nzBordered>
				<thead>
					<tr>
						<th>Name</th>
						<th>Description</th>
						<th nzAlign="center">Compulsory</th>
						<th nzAlign="center">Include</th>
						<th nzAlign="center">Premium</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let line of offerLinesTable.data">
						<td>{{ line.name }}</td>
						<td>{{ line.description }}</td>
						<td nzAlign="center">
							<nz-tag [nzColor]="line.compulsory ? 'blue' : 'default'">
								{{ line.compulsory ? 'Yes' : 'No' }}
							</nz-tag>
						</td>
						<td nzAlign="center">
							<label *ngIf="line.compulsory" nz-checkbox [ngModel]="true" [ngModelOptions]="{standalone: true}"
								[nzDisabled]="true">
							</label>
							<label *ngIf="!line.compulsory" nz-checkbox [ngModel]="isLineSelected(line)"
								[ngModelOptions]="{standalone: true}" (ngModelChange)="toggleLine(line, $event)">
							</label>
						</td>
						<td nzAlign="right">
							{{getOfferLinePrice(line)}}
						</td>
					</tr>
				</tbody>
			</nz-table>

			<ng-container *ngIf="isDependantEnabled">
				<nz-divider class="mt-3" nzText="Dependants"></nz-divider>

				<nz-table #dependantTable [nzData]="dependantWrappers" [nzShowPagination]="false" nzSize="small" nzBordered>
					<thead>
						<tr>
							<th>Action</th>
							<th>Name</th>
							<th>Surname</th>
							<th>ID Number</th>
							<th>Age</th>
							<th>Relation</th>
							<th>State</th>
							<th>Rules</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let item of dependantWrappers">
							<td>
								<button nz-button nzType="dashed" [disabled]="policyForm!.invalid" class="mt-1" (click)="editDependant(item)">
									Edit
								</button>
							</td>
							<td>{{ item.dependant.name }}</td>
							<td>{{ item.dependant.surname }}</td>
							<td>{{ item.dependant.idNumber }}</td>
							<td>{{ item.age }}</td>
							<td>{{item.dependant.relationship}}</td>

							<td *ngIf="item.eligible">
								<label nz-checkbox
									[ngModel]="item.selected"
									(ngModelChange)="toggleDependant(item, $event)"
									[ngModelOptions]="{standalone: true}">
									Covered
								</label>
							</td>
							<td *ngIf="!item.eligible">
								<button nz-button *ngIf="!item.extended" (click)="openExtendedCoverModal(item)">Add extended cover</button>
								<button nz-button *ngIf="item.extended" (click)="openExtendedCoverModal(item)">Extended: {{item.extended.name}}</button>
							</td>
							<td>
								<ul *ngIf="item.failedRules.length>0">
									<li *ngFor="let rule of item.failedRules">{{rule.ruleType}} - {{rule.reason}}</li>
								</ul>
							</td>
						</tr>
					</tbody>
				</nz-table>
				<button nz-button nzType="dashed" [disabled]="policyForm!.invalid" class="mt-1" (click)="addDependant()">
					Add Dependant
				</button>
			</ng-container>


			<nz-divider class="mt-3" nzText="Beneficiaries"></nz-divider>
			<nz-table #dependantTable [nzData]="policy.beneficiaries" [nzShowPagination]="false" nzSize="small" nzBordered>
				<thead>
					<tr>
						<th>Action</th>
						<th>Name</th>
						<th>Surname</th>
						<th>ID Number</th>
						<th>Relation</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let item of policy.beneficiaries">
						<td>
							<button nz-button nzType="dashed" [disabled]="policyForm!.invalid" class="mt-1" (click)="editBeneficiary(item)">
								Edit
							</button>
						</td>
						<td>{{ item.name }}</td>
						<td>{{ item.surname }}</td>
						<td>{{ item.idNumber }}</td>
						<td>{{item.relationship}}</td>
					</tr>
				</tbody>
			</nz-table>
			<button nz-button nzType="dashed" [disabled]="policyForm!.invalid" class="mt-1" (click)="addBeneficiary()">
				Add Beneficiary
			</button>

			<div class="mt-4" style="text-align: right;">
				<button nz-button nzType="primary" [disabled]="policyForm!.invalid" (click)="submit()">
					Update Policy
				</button>
			</div>
		</form>
	</div>
</nz-spin>
